import React, {useState} from 'react'
import {Tab, Tabs} from 'react-bootstrap'
import {reportTypeObj} from '../../Utils/commonModels'
import ScheduledReport from './ScheduledReport/ScheduledReport'
import IncidentReport from './IncidentReport/IncidentReport'
const {incidentReport, scheduledReport} = reportTypeObj
const incidentTabName = 'incident'
const scheduledTabName = 'scheduled'

const Reports = () => {
  const [selectedTab, setSelectedTab] = useState(scheduledTabName)
  const isScheduledTab = selectedTab === scheduledTabName
  const isIncidentTab = selectedTab === incidentTabName
  const handleTabChange = (tabName: string | null) => {
    if (!tabName) return
    setSelectedTab(tabName)
  }
  return (
    <div className='bg-white rounded-lg px-4 py-3'>
      <Tabs id='report-tabs' activeKey={selectedTab} onSelect={handleTabChange} className='mb-3'>
        <Tab eventKey={scheduledTabName} title={scheduledReport}>
          <ScheduledReport isScheduledTab={isScheduledTab} />
        </Tab>
        <Tab eventKey={incidentTabName} title={incidentReport}>
          <IncidentReport isIncidentTab={isIncidentTab} />
        </Tab>
      </Tabs>
    </div>
  )
}
export default Reports
